import classNames from 'classnames';
import { Component, ReactNode } from 'react';

interface ITabLinkProps {
	children: ReactNode;
	tabTo: string;
	namespace?: string;
	handleSelect?: (tabName, namespace) => void;
	isActive?: boolean;
	className: string;
	activeClassName: string;
}

export default class TabLink extends Component<ITabLinkProps> {
	render() {
		const { children, tabTo, namespace, handleSelect, isActive, className, activeClassName } = this.props;

		const tabLinkClassNames = classNames(className, {
			[activeClassName]: isActive,
		});

		return (
			<div className={tabLinkClassNames} onClick={handleSelect.bind(this, tabTo, namespace)}>
				{children}
			</div>
		);
	}
}
